var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root-faq-page"},[_c('div',{staticClass:"inner-wrap"},[_c('faq-partial')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }